function userAgentUtils() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/Windows NT/i.test(userAgent)) return 'Web';
  if (/Android/i.test(userAgent)) {
    return /Mobile/i.test(userAgent) ? 'Android' : 'Tablet';
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  if (/Prerender/.test(userAgent)) {
    return 'Crawler';
  }

  if (
    (navigator.maxTouchPoints > 0 &&
      window.matchMedia('(hover: none)').matches) ||
    /iPad/i.test(userAgent)
  ) {
    return 'Tablet';
  }
  return 'Web';
}

export { userAgentUtils };
